module.exports = __webpack_public_path__ + "img/docs_transform.8400decb.png";